import { Component, ViewChild, inject } from "@angular/core";
import { NEVER, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { CstDialogResult } from "src/app/common-components/dialogs/cst-dialog-enums";
import { CstDialogsService } from "src/app/common-components/dialogs/cst-dialogs.service";
import {
  ICstGuiCommand,
  ICstListViewState,
} from "src/app/common-components/list-view/models";
import {
  CstTileGridComponent,
  ITileGridTile,
} from "src/app/common-components/tile-grid/tile-grid.component";
import { CstNavigationService } from "src/app/services/cst-navigation.service";
import { UserService } from "src/app/services/user.service";
import {
  FacilityInformationPageClientProvider,
  FacilityInformationPageTemplateDeleteCommand,
} from "src/app/web-api/web-api";

@Component({
    selector: "app-facility-information-pages-grid",
    templateUrl: "./facility-information-pages-grid.component.html",
    styleUrls: ["./facility-information-pages-grid.component.scss"],
    standalone: false
})
export class AnlageApiFacilityInformationPagesGridComponent {
  private _client = inject(FacilityInformationPageClientProvider);
  private _userService = inject(UserService);
  private _nav = inject(CstNavigationService);
  private _dlg = inject(CstDialogsService);


  @ViewChild(CstTileGridComponent) templatesGrid: CstTileGridComponent;

  public actions: ICstGuiCommand<ITileGridTile>[] = [
    {
      canExecute: (tile) => this._canDelete(tile),
      execute: (tile) => this._onDelete(tile),
      tooltip: $localize`:@@AnlageAPI_FacilityInformationPages_TemplateDelete:Archive this Template`,
      icon: "archive",
    },
  ];

  public fetchData = (
    state: ICstListViewState
  ): Observable<{ total: number; data: ITileGridTile[] }> => {
    return this._client
      .templateListGet(state.pagination.offset, state.pagination.pageSize)
      .pipe(
        map((result) => ({
          total: result.total,
          data: result.data.map(
            (x) =>
              ({
                data: { id: x.id, insertedUserID: x.insertedUserID },
                label: x.label,
                description: x.description,
                bottomRightInfo: x.insertedUser,
              } as ITileGridTile)
          ),
        }))
      );
  };

  public canUpdate(tile: ITileGridTile) {
    return (
      tile?.data &&
      tile.data.insertedUserID === this._userService.CurrentUser.id
    );
  }
  public onUpdate(tile: ITileGridTile) {
    if (!this.canUpdate(tile)) {
      return;
    }
    this._nav.navigateTo_Facilities_InformationPages_Editor(tile.data.id);
  }

  private _canDelete(tile: ITileGridTile) {
    return (
      tile?.data &&
      tile.data.insertedUserID === this._userService.CurrentUser.id
    );
  }
  private _onDelete(tile: ITileGridTile) {
    if (!this._canDelete(tile)) {
      return;
    }
    this._dlg
      .AskYesCancel(
        $localize`:@@AnlageAPI_FacilityInformationPages_TemplateDeleteConfirm:Do you really want to delete this template?`
      )
      .pipe(
        switchMap((dlgResult) => {
          if (dlgResult !== CstDialogResult.Yes) {
            return NEVER;
          }
          const cmd = new FacilityInformationPageTemplateDeleteCommand({
            id: tile.data.id,
          });
          return this._client.templateDelete(cmd);
        })
      )
      .subscribe((_) => {
        this.templatesGrid.refresh();
      });
  }
}
